export const RegisterTrackingKey = 'socialRegister';
